import React, { Component } from "react"

/* Redux */
import { connect } from "react-redux"

/* Translate */
import { t } from "../../translates/translate"

/* Components */
import { InnerLayout } from "../../components"

/* Modal */
import Modal from "react-modal"

/* REST API */
import { bonus } from "../../api/Bonus"

/* Helpers */
import { utils } from "../../helpers"

/* Icons */
import { CloseIcon, SettingsIcon, JackpotIcon, SafeIcon, PlusIcon, EditIcon, OperatorIcon, LinkIcon } from "./BonusIcons"

/* Utils */
import { toNumber } from "./BonusUtils"

/* Widgets */
import JackpotUpdate from "./JackpotUpdate"
import JackpotConnect from "./JackpotConnect"


/* Widget Jackpot Modal */
class JackpotModal extends Component {

    constructor() {
        super()

        this.state = {
            data: [],
            status: "loading",

            update: false,
            active: null,

            create: false,
        }
    }

    componentDidMount = () => {
        this.load()
    }

    /* Load Action */
    load = () => {
        bonus().then((response) => {
            if (response.status === 200) {
                this.setState({ status: "ok", data: response.data })
            }
            else if (response.status === 401 || response.status === 403) {
                this.setState({ status: "permission", data: [] })
            }
            else if (response.status === 498) {
                this.setState({ status: "key", data: [] })
            }
            else {
                this.setState({ status: "error", data: [] })
            }
        }).catch(() => {
            this.setState({ status: "network", data: [] })
        })
    }

    /* Close Action */
    close = () => {

        /* Fields */
        const { close } = this.props

        /* Close */
        close()
    }

    /* Short Sign Of An Operator */
    getSign = (name) => {

        /* Check Name */
        if (!name || String(name).trim() === "") {
            return "?"
        }

        /* Send Result */
        return String(name).trim().charAt(0).toUpperCase()
    }

    /* Draw The Totals Of Every Connected Operator */
    _summary = () => {

        /* Fields */
        const { data } = this.state

        /* Amounts */
        const jackpot = data.reduce((total, item) => total + toNumber(item.jackpot), 0)
        const cash = data.reduce((total, item) => total + toNumber(item.score), 0)
        const enabled = data.filter((item) => parseInt(item.enabled) === 1).length

        return (
            <div className="bns--jp-summary">

                <div className="bns--jp-sum jackpot">
                    <div className="bns--jp-sum-title">
                        <JackpotIcon size={12} />
                        {t("bns.jackpotTotal")}
                    </div>
                    <div className="bns--jp-sum-value">{utils.convertor(jackpot, "USD", 1)}</div>
                </div>

                <div className="bns--jp-sum cash">
                    <div className="bns--jp-sum-title">
                        <SafeIcon size={12} />
                        {t("bns.cashTotal")}
                    </div>
                    <div className="bns--jp-sum-value">{utils.convertor(cash, "USD", 1)}</div>
                </div>

                <div className="bns--jp-sum operators">
                    <div className="bns--jp-sum-title">
                        <OperatorIcon size={12} />
                        {t("bns.connectedCount")}
                    </div>
                    <div className="bns--jp-sum-value">
                        {data.length}
                        <span className="bns--jp-sum-note">{t("bns.activeCount")} {enabled}</span>
                    </div>
                </div>

            </div>
        )
    }

    /* Draw One Operator */
    _operator = (item, index) => {

        /* Fields */
        const enabled = parseInt(item.enabled) === 1
        const live = parseInt(item.live) === 1

        return (
            <div onClick={() => this.setState({ active: item, update: true })} className="bns--jp-card" key={`${index}-${item.id}-${item.live}`}>

                <div className="bns--jp-card-head">

                    <div className="bns--jp-sign">{this.getSign(item.name)}</div>

                    <div className="bns--jp-card-text">
                        <div className="bns--jp-name">{utils.checkValue(item.name, "—")}</div>
                        <div className={`bns--jp-status ${enabled ? "on" : "off"}`}>
                            <i />
                            {enabled ? t("bns.statusActive") : t("bns.statusDisabled")}
                        </div>
                        <div className={`bns--jp-pool ${live ? "live" : "electron"}`}>{live ? t("bns.poolLive") : t("bns.poolElectron")}</div>
                    </div>

                    <div className="bns--jp-edit">
                        <EditIcon size={13} />
                    </div>

                </div>

                <div className="bns--jp-values">

                    <div className="bns--jp-value jackpot">
                        <div className="bns--jp-value-title">
                            <JackpotIcon size={11} />
                            JACKPOT
                        </div>
                        <div className="bns--jp-value-amount">{utils.convertor(item.jackpot, "USD", 1)}</div>
                    </div>

                    <div className="bns--jp-value cash">
                        <div className="bns--jp-value-title">
                            <SafeIcon size={11} />
                            {t("bns.cash")}
                        </div>
                        <div className="bns--jp-value-amount">{utils.convertor(item.score, "USD", 1)}</div>
                    </div>

                </div>

            </div>
        )
    }

    /* Draw Content */
    _content = () => {

        /* Fields */
        const { status, data } = this.state

        /* Layout */
        if (status !== "ok") {
            return <InnerLayout status={status} reload={() => this.load()} />
        }

        /* Check Data */
        if (data.length === 0) {

            return (
                <div className="bns--jp-empty">

                    <div className="bns--jp-empty-icon">
                        <JackpotIcon size={30} />
                    </div>

                    <h3>{t("bns.jackpotEmpty")}</h3>
                    <p>{t("bns.jackpotEmptyText")}</p>

                    <div onClick={() => this.setState({ create: true })} className="bns--button primary">
                        <PlusIcon size={15} />
                        {t("bns.connect")}
                    </div>

                </div>
            )
        }

        return (
            <div className="bns--jp-list">

                {data.map((item, index) => this._operator(item, index))}

                <div onClick={() => this.setState({ create: true })} className="bns--jp-add">
                    <PlusIcon size={18} />
                    <span>{t("bns.connect")}</span>
                </div>

            </div>
        )
    }

    render = () => {

        /* Fields */
        const { visible, socket } = this.props
        const { status, data, update, active, create } = this.state

        return (
            <Modal
                isOpen={visible}
                onRequestClose={() => this.close()}
                className="bns--modal"
                overlayClassName="bns--overlay"
                closeTimeoutMS={200}
            >

                <div className="bns--modal-header">

                    <div className="bns--modal-icon gold">
                        <SettingsIcon size={18} />
                    </div>

                    <div className="bns--modal-head-text">
                        <h2>{t("bns.jackpotTitle")}</h2>
                        <p>{t("bns.jackpotSubtitle")}</p>
                    </div>

                    <div onClick={() => this.close()} className="bns--modal-close">
                        <CloseIcon />
                    </div>

                </div>

                <div className="bns--modal-body">

                    {/* Draw Totals */}
                    {status === "ok" && data.length > 0 && this._summary()}

                    {/* Draw Operators */}
                    {this._content()}

                </div>

                <div className="bns--modal-footer space jp">

                    <div className="bns--jp-hint">
                        <LinkIcon size={13} />
                        <span>{t("bns.jackpotHint")}</span>
                    </div>

                    <div onClick={() => this.close()} className="bns--button ghost">{t("common.close")}</div>

                </div>

                {update &&
                    <JackpotUpdate
                        visible={update}
                        data={active}
                        close={() => this.setState({ update: false, active: null }, () => this.load())}
                        socket={socket}
                    />
                }

                {create &&
                    <JackpotConnect
                        visible={create}
                        close={() => this.setState({ create: false }, () => this.load())}
                    />
                }

            </Modal>
        )
    }

}

const mapStateToProps = (state) => ({
    language: state.language,
})

export default connect(mapStateToProps)(JackpotModal)
